import { ModalFooter, ModalFooterButton } from '@/components/Modal'

import { useController } from '../hooks/useController'
import { useDeleteRoadSegment } from '../hooks/useDeleteRoadSegment'

import { useTexts } from '../useTexts'

export function Footer() {
  const texts = useTexts()
  const { status, close } = useController()
  const deleteRoadSegment = useDeleteRoadSegment()

  return (
    <ModalFooter
      primaryAction={
        <ModalFooterButton
          disabled={status !== 'ready'}
          onClick={deleteRoadSegment}
          variant="contained"
          testid="modal-primary-button"
          color="error"
        >
          {texts.confirmButtonTitle}
        </ModalFooterButton>
      }
      secondaryAction={
        <ModalFooterButton onClick={close} testid="modal-secondary-button">
          {texts.cancelButtonTitle}
        </ModalFooterButton>
      }
    />
  )
}
